export default {
  title: {
    it: 'Log in om een avatar te maken'
  },

  text: {
    it: 'Als je een avatar wilt maken, moet je eerst even inloggen!'
  },

  button: {
    it: 'Log in'
  }
};
